var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "订单详情",
            visible: _vm.visible,
            width: "960px",
            "close-on-click-modal": false,
            "before-close": _vm.handleClose,
            "custom-class": "shopcar-detail-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "detail-wrapper",
            },
            [
              _c("section", { staticClass: "detail-section" }, [
                _c("div", { staticClass: "section-title" }, [
                  _c("i", { staticClass: "el-icon-s-order" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("基础信息")]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-grid" }, [
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("订单编号："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.detail.orderNo || "--")),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "info-item" },
                    [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("订单状态："),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-tag",
                        {
                          attrs: {
                            size: "small",
                            type: _vm.getOrderStatusType(
                              _vm.detail.orderStatusName
                            ),
                          },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.detail.orderStatusName || "--") +
                              "\n            "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("下单时间："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.detail.orderTime || "--")),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("关联小程序："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.detail.appName || "--")),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("支付时间："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.detail.payTime || "--")),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "label" }, [_vm._v("返金豆：")]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value fudou-value" }, [
                      _vm._v(_vm._s(_vm.detail.returnFudou || 0)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("用户手机号："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.detail.phone || "--")),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "info-item" },
                    [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("用户车牌号："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.detail.plateNo || "--")),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticStyle: { "margin-left": "10px" },
                          attrs: { type: "text", size: "small" },
                          on: { click: _vm.openEditPlateNo },
                        },
                        [
                          _c("i", { staticClass: "el-icon-edit" }),
                          _vm._v(" 编辑\n            "),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("停车场名称："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.detail.parkName || "--")),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("停车场编码："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.detail.parkCode || "--")),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "info-item" },
                    [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("月卡状态："),
                      ]),
                      _vm._v(" "),
                      _vm.cardStatusText !== "--"
                        ? _c(
                            "el-tag",
                            {
                              attrs: {
                                size: "small",
                                type: _vm.getCardStatusType(_vm.cardStatusText),
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.cardStatusText) +
                                  "\n            "
                              ),
                            ]
                          )
                        : _c("span", { staticClass: "value" }, [_vm._v("--")]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "info-item" },
                    [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("冻结状态："),
                      ]),
                      _vm._v(" "),
                      _vm.freezeStatusText !== "--"
                        ? _c(
                            "el-tag",
                            {
                              attrs: {
                                size: "small",
                                type: _vm.getFreezeStatusType(
                                  _vm.freezeStatusText
                                ),
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.freezeStatusText) +
                                  "\n            "
                              ),
                            ]
                          )
                        : _c("span", { staticClass: "value" }, [_vm._v("--")]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("月卡开始时间："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.detail.validStartTime || "--")),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("月卡到期时间："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.detail.validEndTime || "--")),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("使用人群："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(
                        _vm._s(_vm.detail.restrictedUserGroupName || "--")
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("工会会员是否使用："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(
                        _vm._s(_vm.detail.isUnionMemberUsed ? "是" : "否")
                      ),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "section",
                { staticClass: "detail-section" },
                [
                  _c("div", { staticClass: "section-title" }, [
                    _c("i", { staticClass: "el-icon-shopping-cart-2" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("商品信息")]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      attrs: {
                        data: _vm.goodsListData,
                        border: "",
                        size: "small",
                        "header-cell-style": {
                          fontWeight: "bold",
                          background: "#f5f7fa",
                        },
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "productName",
                          label: "商品名称",
                          "min-width": "150",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "unitPrice",
                          label: "单价",
                          "min-width": "100",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", { staticClass: "price-text" }, [
                                  _vm._v(
                                    "￥" + _vm._s(scope.row.unitPrice || 0)
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "quantity",
                          label: "数量",
                          "min-width": "80",
                          align: "center",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "totalPrice",
                          label: "总价",
                          "min-width": "100",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", { staticClass: "price-text" }, [
                                  _vm._v(
                                    "￥" + _vm._s(scope.row.totalPrice || 0)
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "orderStatusName",
                          label: "订单状态",
                          "min-width": "100",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      size: "mini",
                                      type: _vm.getOrderStatusType(
                                        scope.row.orderStatusName
                                      ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          scope.row.orderStatusName || "--"
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("section", { staticClass: "detail-section" }, [
                _c("div", { staticClass: "section-title" }, [
                  _c("i", { staticClass: "el-icon-bank-card" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("交易信息")]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "trade-info" }, [
                  _c(
                    "div",
                    { staticClass: "trade-line" },
                    [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("订单金额："),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "value amount-highlight" }, [
                        _vm._v("￥" + _vm._s(_vm.detail.totalPrice || 0)),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "sub" }, [
                        _vm._v("\n              （福豆："),
                        _c("span", { staticClass: "fudou-amount" }, [
                          _vm._v("￥" + _vm._s(_vm.detail.useIntegral || 0)),
                        ]),
                        _vm._v("，\n              微信："),
                        _c("span", { staticClass: "wechat-amount" }, [
                          _vm._v("￥" + _vm._s(_vm.detail.paidPrice || 0)),
                        ]),
                        _vm._v("）\n            "),
                      ]),
                      _vm._v(" "),
                      _vm.detail.useIntegral > 0
                        ? _c(
                            "el-button",
                            {
                              staticClass: "link-btn",
                              attrs: { type: "text" },
                              on: { click: _vm.handleViewBeans },
                            },
                            [
                              _c("i", { staticClass: "el-icon-view" }),
                              _vm._v(" 查看福豆\n            "),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "trade-line" }, [
                    _c("span", { staticClass: "label" }, [
                      _vm._v("优惠券信息："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.detail.couponName || "--")),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.detail.couponDiscount > 0
                    ? _c("div", { staticClass: "trade-line discount-line" }, [
                        _c("i", { staticClass: "el-icon-discount" }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            "优惠券优惠：- ￥" +
                              _vm._s(_vm.detail.couponDiscount)
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _vm.detail.refundOrderInformation
                ? _c("section", { staticClass: "detail-section" }, [
                    _c("div", { staticClass: "section-title" }, [
                      _c("i", { staticClass: "el-icon-refresh-left" }),
                      _vm._v(" "),
                      _c("span", [_vm._v("退款信息")]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-grid" }, [
                      _c(
                        "div",
                        { staticClass: "info-item" },
                        [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("退款状态："),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-tag",
                            { attrs: { size: "small", type: "warning" } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.detail.refundOrderInformation
                                      .refundStatusName || "--"
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("总退款金额："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value refund-amount" }, [
                          _vm._v(
                            "￥" +
                              _vm._s(
                                _vm.detail.refundOrderInformation
                                  .refundAmount || 0
                              )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("平台微信退款："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value refund-amount" }, [
                          _vm._v(
                            "￥" +
                              _vm._s(
                                _vm.detail.refundOrderInformation
                                  .refundPaidAmount || 0
                              )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("福豆退款："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value fudou-value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.detail.refundOrderInformation
                                .refundUseIntegral || 0
                            )
                          ),
                        ]),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.detail.thirdOrderInformation
                ? _c("section", { staticClass: "detail-section" }, [
                    _c("div", { staticClass: "section-title" }, [
                      _c("i", { staticClass: "el-icon-link" }),
                      _vm._v(" "),
                      _c("span", [_vm._v("第三方机构信息")]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-grid" }, [
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("订单类型："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.detail.thirdOrderInformation.orderTypeName ||
                                "--"
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("订单编号："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.detail.thirdOrderInformation.orderCode || "--"
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "info-item" },
                        [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("订单状态："),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                size: "small",
                                type: _vm.getOrderStatusType(
                                  _vm.detail.thirdOrderInformation
                                    .orderStatusName
                                ),
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.detail.thirdOrderInformation
                                      .orderStatusName || "--"
                                  ) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("下单时间："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.detail.thirdOrderInformation.orderTime || "--"
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("停车场："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.detail.thirdOrderInformation.parkName || "--"
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("车牌号："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.detail.thirdOrderInformation.plateNo || "--"
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("应收金额(订单金额)："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value amount-text" }, [
                          _vm._v(
                            "￥" +
                              _vm._s(
                                _vm.detail.thirdOrderInformation.receivables ||
                                  0
                              )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("实收金额："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value amount-text" }, [
                          _vm._v(
                            "￥" +
                              _vm._s(
                                _vm.detail.thirdOrderInformation.received || 0
                              )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("优惠金额："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value discount-amount" }, [
                          _vm._v(
                            "￥" +
                              _vm._s(
                                _vm.detail.thirdOrderInformation.discount || 0
                              )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("所属区域："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.detail.thirdOrderInformation.areaCode || "--"
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("第三方支付流水号："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.detail.thirdOrderInformation
                                .threeStatementCode || "--"
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("交易流水编号："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.detail.thirdOrderInformation
                                .transactionStatementCode || "--"
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("月卡开始时间："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.detail.thirdOrderInformation.validStartTime ||
                                "--"
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("月卡到期时间："),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.detail.thirdOrderInformation.validEndTime ||
                                "--"
                            )
                          ),
                        ]),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("CardStatusChangeRecords", {
                attrs: { records: _vm.statusChangeRecords },
              }),
              _vm._v(" "),
              _c(
                "section",
                { staticClass: "detail-section" },
                [
                  _c("div", { staticClass: "section-title" }, [
                    _c("i", { staticClass: "el-icon-document" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("操作日志列表")]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      attrs: {
                        data: _vm.detail.operationLogs || [],
                        border: "",
                        size: "small",
                        "empty-text": "暂无日志",
                        "header-cell-style": {
                          fontWeight: "bold",
                          background: "#f5f7fa",
                        },
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "time",
                          label: "时间",
                          "min-width": "160",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "operator",
                          label: "操作人",
                          "min-width": "120",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "logDetail",
                          label: "日志明细",
                          "min-width": "240",
                          "show-overflow-tooltip": "",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "requestParam",
                          label: "请求参数",
                          "min-width": "200",
                          "show-overflow-tooltip": "",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("关闭"),
              ]),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "福豆使用明细",
            visible: _vm.beansDialogVisible,
            width: "700px",
            "close-on-click-modal": false,
            "custom-class": "beans-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.beansDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "beans-detail-wrapper" },
            [
              _c("div", { staticClass: "beans-summary" }, [
                _c("div", { staticClass: "summary-card" }, [
                  _c("div", { staticClass: "summary-icon" }, [
                    _c("i", { staticClass: "el-icon-coin" }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "summary-content" }, [
                    _c("div", { staticClass: "summary-label" }, [
                      _vm._v("本次使用福豆"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "summary-value" }, [
                      _vm._v(_vm._s(_vm.detail.useIntegral || 0)),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("el-divider"),
              _vm._v(" "),
              _c("div", { staticClass: "beans-info-section" }, [
                _c("div", { staticClass: "info-title" }, [
                  _c("i", { staticClass: "el-icon-info" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("使用详情")]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "beans-info-list" }, [
                  _c("div", { staticClass: "beans-info-item" }, [
                    _c("span", { staticClass: "item-label" }, [
                      _vm._v("订单编号："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "item-value" }, [
                      _vm._v(_vm._s(_vm.detail.orderNo || "--")),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "beans-info-item" }, [
                    _c("span", { staticClass: "item-label" }, [
                      _vm._v("使用时间："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "item-value" }, [
                      _vm._v(
                        _vm._s(
                          _vm.detail.payTime || _vm.detail.orderTime || "--"
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "beans-info-item" }, [
                    _c("span", { staticClass: "item-label" }, [
                      _vm._v("订单金额："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "item-value amount-highlight" }, [
                      _vm._v("￥" + _vm._s(_vm.detail.totalPrice || 0)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "beans-info-item" }, [
                    _c("span", { staticClass: "item-label" }, [
                      _vm._v("福豆抵扣："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "item-value fudou-amount" }, [
                      _vm._v(_vm._s(_vm.detail.useIntegral || 0) + " 福豆"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "beans-info-item" }, [
                    _c("span", { staticClass: "item-label" }, [
                      _vm._v("微信支付："),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "item-value wechat-amount" }, [
                      _vm._v("￥" + _vm._s(_vm.detail.paidPrice || 0)),
                    ]),
                  ]),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.beansDialogVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "编辑车牌号",
            visible: _vm.editPlateNoVisible,
            width: "500px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.editPlateNoVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "editPlateNoForm",
              attrs: { model: _vm.editPlateNoForm, "label-width": "120px" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "原车牌号：" } },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.editPlateNoForm.oldPlateNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.editPlateNoForm, "oldPlateNo", $$v)
                      },
                      expression: "editPlateNoForm.oldPlateNo",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "新车牌号：",
                    prop: "plateNo",
                    rules: [
                      {
                        required: true,
                        message: "请输入新车牌号",
                        trigger: "blur",
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入新车牌号", clearable: "" },
                    model: {
                      value: _vm.editPlateNoForm.plateNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.editPlateNoForm, "plateNo", $$v)
                      },
                      expression: "editPlateNoForm.plateNo",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.editPlateNoVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.editPlateNoLoading },
                  on: { click: _vm.handleSubmitEditPlateNo },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }